import React from 'react';

import { withToolbarContext } from './../../../../ricos-context';

import type { ToolbarItemProps } from '../../../types';
import { ToolbarButton } from '../ToolbarButton';

const ToggleButton = ({ toolbarItem, onClick, context, dataHook }: ToolbarItemProps) => {
  const { isMobile, t } = context || { t: (s: string) => s };

  const tooltip = toolbarItem.presentation?.tooltip;

  return (
    <ToolbarButton
      isMobile={isMobile}
      active={toolbarItem.attributes.active}
      disabled={toolbarItem.attributes.disabled}
      tooltip={t(tooltip)}
      onClick={onClick}
      icon={toolbarItem.presentation?.icon}
      dataHook={`${dataHook} ${toolbarItem.attributes.active ? 'active' : 'disabled'}`}
    />
  );
};

export default withToolbarContext(ToggleButton);
